import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { match as Match } from "react-router-dom";
import NewsForm from "../form";
import { withTwoColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";

interface Props {
  match: Match<{ cid: string; id: string }>;
  intl: IntlShape;
  backURL: string;
}

const NewsUpdate = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: "page.news.update.document.title" })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-news-update"
        goBackURL={backURL}
      />

      <NewsForm {...props} edition />
    </>
  );
};

export default withTwoColLayout(injectIntl(NewsUpdate));
